export default "__VITE_ASSET__d50814fd__"